<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <div class="article-wrap" style="height: 100%;">
        <div v-if="infoDetail.id" class="centre_content nano" id="centre_contents" ref="centre_contents">
          <div id="consult_left_content">
            <div class="table-top-box">
              <span class="fl left">{{ title }}</span>
              <span class="fr right" @click="back()">
                <Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />{{ $t("buttons.back") }}
              </span>
              <span class="fr right  div-xs-hidden" @click="exportDetail"><span class="word-png"></span>{{
                $t("buttons.export") }}</span>
              <!-- <span class="fr right"><Icon type="md-star" style="font-size: 20px;"/></span> -->
              <span class="fr right">
                <Icon color="#008bce" @click="editFavorite" :type="infoDetail.favStatus ? 'md-star' : 'md-star-outline'"
                  style="font-size: 20px;" />
              </span>
            </div>
          </div>
          <div class="nano-content p-4" id="spanblock" style="top:40px;padding-top: 0px !important;">
            <!--<p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>-->
            <h1 class="information_article_headline">
              {{ infoDetail.title | filterEmpty }}
            </h1>
            <p class="information_article_info">
              <span class="mr-2">{{ $t("label.information.detail.time")
                }}{{ infoDetail.time | filterEmpty }}
              </span>
              <span v-if="infoDetail.author && infoDetail.author > 0">
                {{ $t("label.information.detail.author") }}
                <span class="mr-2">{{ infoDetail.author | filterEmpty }} </span>
              </span>
              <span v-if="infoDetail.sourceType">{{ $t("label.information.detail.source")
                }}{{ infoDetail.sourceType | filterEmpty }}</span>
              <span v-if="false" style="float:right;">{{ $t("label.information.publishDate")
                }}{{ infoDetail.publishDate | filterEmpty }}</span>
            </p>
            <div class="information_article_abstract rounded" v-if="infoDetail.summary">
              <p>
                {{ $t("label.information.detail.summary")
                }}{{ infoDetail.summary }}
              </p>
            </div>
             <!-- 招标项目,且存在附件信息 -->
            <iframe class="iframe-content" :src="infoDetail.fileDownloadPath" frameborder="0" v-if="infoDetail.isBidding===1&&infoDetail.fileDownloadPath" height="800px" width="100%"></iframe>
            <!-- 文章 -->
            <div v-else class="information_article_details text-indent2" v-html="`${infoDetail.content}`"></div>
            <div v-for="(pro, index) in infoDetail.projectList" :key="index">
              <el-link type="primary" :underline="false" @click="linkProject(pro)">{{ pro.projectName }}</el-link>
            </div>
            <p class="pbr-detail-box-link">
              <el-link type="primary" target="_blank" :underline="false"
                v-if="isSourceAddressValidate(infoDetail.sourceAddress)" @click="copySourceAddress">{{
                  $t("label.information.detail.originalLink") }}</el-link>
              <template v-if="!infoDetail.isOrigin">
                <el-link type="primary" :underline="false" @click="fetchOrigin">{{
                  $t("label.information.detail.originalDetails") }}</el-link>
              </template>
              <template v-if="isTranslate">
                <el-link type="primary" :underline="false" @click="fetchTranslation">{{
                  $t("label.information.detail.translateDetails")
                  }}</el-link>
              </template>
            </p>
            <p v-if="!infoDetail.isOrigin" class="information_article_info">
              {{ $t("message.info.articleTranslateHint") }}
            </p>
          </div>
        </div>
      </div>
      <!--      <div class="table-top-box">-->
      <!--        <span class="fl left">资讯详情</span>-->
      <!--        <span class="fr right" @click="back()"><Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />返回</span>-->
      <!--        <span class="fr right" @click="exportDetail"><span class="pdf-back"></span>导出PDF</span>-->
      <!--        &lt;!&ndash; <span class="fr right"><Icon type="md-star" style="font-size: 20px;"/></span> &ndash;&gt;-->
      <!--         <span class="fr right"><Icon color="#008bce" @click="editFavorite" :type="infoDetail.favStatus ? 'md-star' : 'md-star-outline'" style="font-size: 20px;"/></span>-->
      <!--      </div>-->
      <!--      <div class="pbr-detail-box">-->
      <!--        <h3 class="pbr-detail-box-title">{{infoDetail.title | filterEmpty}}</h3>-->
      <!--        <p class="pbr-detail-box-author">-->
      <!--          <span>{{infoDetail.time| filterEmpty}} </span>-->
      <!--          <span>作者：{{infoDetail.author| filterEmpty}} </span>-->
      <!--          <span>来源：{{infoDetail.source| filterEmpty}}</span>-->
      <!--        </p>-->
      <!--        <p class="pbr-detail-box-summary">【摘要】{{clearSymbol(infoDetail.summary)}}</p>-->
      <!--        <p class="pbr-detail-box-tags">-->
      <!--          <template v-if="infoDetail.keywords">-->
      <!--          <el-tag-->
      <!--            style="margin-right: 4px;"-->
      <!--            v-for="item in infoDetail.keywords.split(';')"-->
      <!--            :key="item"-->
      <!--            size="small"-->
      <!--            effect="plain">-->
      <!--            {{ item }}-->
      <!--          </el-tag></template>-->
      <!--        </p>-->
      <!--        <p class="pbr-detail-box-img">-->
      <!--          <img src="../common/img/detail.jpg" alt="">-->
      <!--        </p>-->
      <!--         <p class="pbr-detail-box-content" v-html="clearSymbol(infoDetail.content)"></p>-->
      <!--       <p class="pbr-detail-box-link">-->
      <!--          <a v-if="isSourceAddressValidate(infoDetail.sourceAddress )" :href="infoDetail.sourceAddress">原文链接</a>-->
      <!--          <el-link type="primary" :underline="false" @click="fetchOrigin" v-if="!isOrigin">原文详情</el-link>-->
      <!--        </p>-->
      <!--      </div>-->
    </div>
    <div class="wrap-box-right">
      <div class="pbr-title">
        {{ $t("label.information.detail.informationAtlas") }}
      </div>
      <AtlasAnalysis :graph="graphData" id="pbr-info-detail-atlas"></AtlasAnalysis>
      <div class="pbr-title">
        {{ $t("label.information.detail.relevantInformation") }}
      </div>
      <normal-list :page-size="6" :data="articleModels" goto="pbrInfoDetail"></normal-list>
    </div>
    <div v-show="false" ref="submitForm">
      <form method="get" target="_blank" enctype="multipart/form-data" :action="action">
        <input name="id" type="text" />
        <input name="from" type="text" value="cn" />
      </form>
    </div>
  </div>
</template>

<script>
import NormalList from "../index/NormalList.vue";
import AtlasAnalysis from "../analysis/AtlasAnalysis";
import { exportFile, contentType } from "../apis/common";
export default {
  name: "pbrInfoDetail",
  components: { NormalList, AtlasAnalysis },
  inject: ["copyToPasteBoard"],
  data() {
    return {
      isTranslate: false,
      graphData: {
        graph: {}
      },
      tags: [
        { label: "国机集团" },
        { label: "几内亚" },
        { label: "EPC" },
        { label: "能源类项目" }
      ],
      infoDetail: {},
      articleModels: [],
      articleLanguage: {},
      forwardRouterCounter: 0,
      isOrigin: false,
      action: this.$pbrApis.exportInfoDetailWordUrl,
      title: ""
    };
  },
  created() {
    // this.fetchDetail()
    // this.fetchProjectReferensInfo()
  },
  mounted() {
    this.title = this.$t("label.information.detail.title");

    if (this.$route.query.type) {
      let type = this.$route.query.type;
      if (type === "project") {
        this.title = this.$t("label.information.detail.projectTitle");
      } else if (type === "risk") {
        this.title = this.$t("label.information.detail.riskTitle");
      } else if (type === "business") {
        this.title = this.$t("label.information.detail.businessTitle");
      }
    }

    if (this.$route.query.key) {
    } else {
      this.$router.replace({ name: "pbrInfo" });
    }
  },
  methods: {
    clearSymbol(content) {
      if (content && content.length > 0) {
        return content.replace(/[?？]{2,}/g, "").replace(/\n+/g, "\n");
      }
      return "--";
    },
    back() {
      this.$router.back();
    },
    linkProject(obj) {
      this.$router.push({
        name: "pbrProjectDetail",
        query: { key: obj.projectId }
      });
    },
    /**
     * 获取原文数据
     */
    fetchOrigin() {
      this.isTranslate = true
      // this.isOrigin = true
      this.fetchDetail({ isOrigin: 1 });
    },
    /**
    * 获取译文数据
    */
    fetchTranslation() {
      this.isTranslate = false
      // this.isOrigin = true
      this.fetchDetail();
    },
    /**
     * 资讯图谱
     */
    fetchGraphData() {
      if (!this.$route.query.key) {
        return;
      }
      this.$pbrApis
        .getRelationMapInfos({
          id: this.$route.query.key,
          conceptId: "1",
          tag: "1"
        })
        .then(res => {
          if (!res) {
            //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
          } else if (res.success) {
            this.graphData.graph = res.result;
          }
        });
    },
    fetchDetail(p) {
      if (!this.$route.query.key) {
        return;
      }
      let params = {
        id: this.$route.query.key,
        lang: "cn",
        ...p
      };
      this.$pbrApis.queryInfoDetail({ params: params }).then(res => {
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.infoDetail = res.result;
          if (
            !this.infoDetail ||
            !this.infoDetail.hasOwnProperty("favStatus")
          ) {
            // this.$iMessage.warning({content: this.$t('message.warning.information.noData'),
            //   duration: 2,
            //   closable: true,
            //   onClose: () => {
            //     this.$router.replace({name: 'pbrInfo'})
            //   }})
          }
        }
      });
    },
    fetchProjectReferensInfo() {
      this.$pbrApis
        .fetchProjectReferensInfo({ id: this.$route.query.key, from: "cn" })
        .then(res => {
          if (!res) {
            //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
          } else if (res.success) {
            this.articleModels = res.result.articleModels;
          }
        });
    },
    editFavorite() {
      debugger;
      if (!this.$route.query.key) {
        return;
      }
      let type = this.infoDetail.favStatus ? "delete" : "add";
      this.$pbrApis
        .editFavorite(type, { id: this.$route.query.key, type: 5 })
        .then(res => {
          if (!res) {
            //this.$iMessage.error({content:  this.$t('message.error.favorite'), duration: 5})
          } else if (res.code === 200) {
            //this.$iMessage.success({content: type === 'add' ?  this.$t('message.success.favorite') :  this.$t('message.success.unfavored'), duration: 5})
            this.fetchDetail();
          }
        })
        .catch(err => {
          //this.$iMessage.error({content: err.message, duration: 5})
        });
    },
    isSourceAddressValidate(value) {
      return value && value.length > 0 && value !== "null";
    },
    exportDetail() {
      // let form = $(this.$refs.submitForm).find('form');
      // form.find("input[name='id']").val(this.$route.query.key);
      // form.submit();
      exportFile(
        this.action,
        { id: this.$route.query.key, from: "cn" },
        this.$t("label.export.info") + this.infoDetail.title,
        contentType.word,
        ".docx"
      );
    },
    reset() {
      this.graphData.graph = {};
      this.infoDetail = {};
      this.articleModels = [];
    },
    copySourceAddress() {
      this.copyToPasteBoard(this.infoDetail.sourceAddress);
    }
  },
  activated() {
    if (this.$route.query.key) {
    } else {
      // this.$iMessage.error({content: this.$t('message.warning.noId'), duration: 5, onClose:()=>{
      //     this.$router.replace({name: 'pbrInfo'})
      //   }})
    }
  },
  updated() {
    this.$nextTick(() => {
      if (this.$store.getters.isHideContainer) {
        document.querySelector(".pbr-box #centre_contents") &&
          document
            .querySelector(".pbr-box #centre_contents")
            .setAttribute("style", "height: calc(100vh - 80px) !important");
      } else {
        document.querySelector(".pbr-box #centre_contents") &&
          document
            .querySelector(".pbr-box #centre_contents")
            .setAttribute("style", "");
      }
    });
  },
  watch: {
    // .pbr-box #centre_contents
    "$store.state.brpaModule.hideContainer": {
      handler(n, o) {
        if (n) {
          document.querySelector(".pbr-box #centre_contents") &&
            document
              .querySelector(".pbr-box #centre_contents")
              .setAttribute("style", "height: calc(100vh - 80px) !important");
        } else {
          document.querySelector(".pbr-box #centre_contents") &&
            document
              .querySelector(".pbr-box #centre_contents")
              .setAttribute("style", "");
        }
      },
      immediate: true
    },
    $route: {
      handler(to, from) {
        if (to.name === "pbrInfoDetail") {
          this.isTranslate = false
          this.fetchDetail();
          this.fetchProjectReferensInfo();
          this.fetchGraphData();

          if (to.query.type) {
            let type = to.query.type;
            if (type === "project") {
              this.title = this.$t("label.information.detail.projectTitle");
            } else if (type === "risk") {
              this.title = this.$t("label.information.detail.riskTitle");
            } else if (type === "business") {
              this.title = this.$t("label.information.detail.businessTitle");
            }
          }

          this.forwardRouterCounter -= 1;
        }
      },
      immediate: true
    }
  },
  filters: {
    filterEmpty: function (value) {
      if (!value || value.length === 0) {
        return "--";
      }
      return value;
    },
    filterSymbol: value => {
      if (value && value.length > 0) {
        return value.replace(/[?？]{2,}/g, "").replace(/\n+/g, "\n");
      }
      return "--";
    }
  }
};
</script>
<style scoped></style>
